'use strict';

const ManagerDevicesV3 = require('../HomeyAPIV3/ManagerDevices');
const Capability = require('./ManagerDevices/Capability');
const Device = require('./ManagerDevices/Device');

class ManagerDevices extends ManagerDevicesV3 {

  static CRUD = {
    ...super.CRUD,
    Capability,
    Device,
  }

}

module.exports = ManagerDevices;
